import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import AirlineSelector from '../AirlineSelector';
import { DateTimePickerFormGroup } from '../../components/dateTimePicker/DateTimePickerCommon';
import DateTimeRangePicker from '../../components/dateTimePicker/DateTimeRangePicker';
import Dropdown from '../../components/Dropdown';
import styles from './work-item-list.module.css';
import { Resolution } from '../../types/waiverWorkItem';
import { WaiverWorkItemSearchCriteria } from '../../types/waiverWorkItem';
import { WaiverAirline } from '../../types/waiver';

interface Props {
  airlines: WaiverAirline[];
  resolutions: Resolution[];
  searchCriteria?: WaiverWorkItemSearchCriteria;
  onChange: (searchCriteria: WaiverWorkItemSearchCriteria) => void;
}

const Options: {text: string, value: string | number | readonly string[] | undefined}[] = [
  { text: 'Any', value: undefined },
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
]

const WaiverWorkItemSearchCriteriaComponent = (props: Props) => {
  return (
    <div className={cn(styles.searchCriteria)}>
      <div className={cn('accordion')}>
        <div className={cn('accordion-group')}>
          <div className={cn('accordion-heading', styles.searchCriteriaTitle)}>
            <div>
              <i className={cn('pull-right', 'sprites')}></i>
              SEARCH CRITERIA
            </div>
          </div>
          <form
            name="searchform"
            role="form"
            className={cn(styles.searchCriteriaContent)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-2">
                <label className="db-text">Airline Code</label>
                <AirlineSelector
                  id="airline-code"
                  airlines={props.airlines}
                  value={props.searchCriteria?.airlineCode?.toString()}
                  onChange={value => {
                    const airlineCode = value?.toString() || '';
                    props.onChange({ ...props.searchCriteria, airlineCode });
                  }}
                />
              </div>
              <div className="col-sm-6 col-md-2">
                <label className="db-text">Has Waivers?</label>
                <Dropdown
                  id="hasWaiversSelector"
                  value={props.searchCriteria?.hasWaivers?.toString()}
                  onChange={value =>
                    props.onChange({
                      ...props.searchCriteria,
                      hasWaivers: value as boolean | undefined,
                    })
                  }
                  options={Options}
                />
              </div>
              <div className="col-sm-6 col-md-3 col-lg-3">
                <div className={cn('row')}>
                  <DateTimePickerFormGroup label="Issuing Date">
                    <DateTimeRangePicker
                      onChange={dateRange =>
                        props.onChange({ ...props.searchCriteria, dateRange })
                      }
                      className='date-range-picker-input'
                      value={props.searchCriteria?.dateRange}
                      ranges={{
                        Today: [moment().startOf('day'), moment().endOf('day')],
                        Yesterday: [
                          moment()
                            .subtract(1, 'day')
                            .startOf('day'),
                          moment()
                            .subtract(1, 'day')
                            .endOf('day'),
                        ],
                        'Last Week': [
                          moment()
                            .subtract(1, 'week')
                            .startOf('week')
                            .startOf('day'),
                          moment()
                            .subtract(1, 'week')
                            .endOf('week')
                            .endOf('day'),
                        ],
                        'Last Month': [
                          moment()
                            .subtract(1, 'month')
                            .startOf('month')
                            .startOf('day'),
                          moment()
                            .subtract(1, 'month')
                            .endOf('month')
                            .endOf('day'),
                        ],
                        'Last 30 Days': [
                          moment()
                            .subtract(29, 'days')
                            .startOf('day'),
                          moment().endOf('day'),
                        ],
                      }}
                    />
                  </DateTimePickerFormGroup>
                </div>
              </div>
              <div className="col-sm-6 col-md-2">
                <label className="db-text">Resolution</label>
                <Dropdown
                  id="resolutionSelector"
                  value={props.searchCriteria?.resolution?.toString()}
                  onChange={value =>
                    props.onChange({
                      ...props.searchCriteria,
                      resolution: value as Resolution | undefined,
                    })
                  }
                  options={[
                    { text: 'Any', value: undefined },
                    ..._(props.resolutions)
                      .map(key => ({ text: key, value: key }))
                      .value(),
                  ]}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WaiverWorkItemSearchCriteriaComponent;